import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomCardList from "../components/Cards";
import PageLoader from "../components/Loader";
import Title from "../components/PageTitle";
import CustomTable from "../components/Table";
import { useToast } from "../components/Toast";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
const Shipment = () => {
  const isMobile = useIsMobile();
  const Toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [kiosk, setKiosk] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const auth = localStorage.getItem("token");
  const [typingTimeout, setTypingTimeout] = useState(null);
  useEffect(() => {
    getKiosk(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const getKiosk = async (page, limit) => {
    setIsLoading(true);
    try {
      const { mappedDoctors, count } = await apiService.fetchKiosk(
        auth,
        page,
        limit
      );
      setKiosk(mappedDoctors);
      setFilteredDoctors(mappedDoctors);
      setTotalCount(count); 
    } catch (error) {
      Toast.error("Error while Fetching");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  useEffect(() => {
    if (typingTimeout) clearTimeout(typingTimeout);

    const timeout = setTimeout(async () => {
      try {
        const { mappedDoctors, count } = await apiService.fetchKiosk(
          auth,
          page,
          10,
          searchQuery
        );
        setTotalCount(count);
        setFilteredDoctors(mappedDoctors);
      } catch (error) {
        console.error("Error fetching Doctors:", error);
        Toast.error("Error while Fetching");
      }
    }, 500); // 500ms debounce

    setTypingTimeout(timeout);

    // Cleanup
    return () => clearTimeout(timeout);
  }, [searchQuery, page]);

  const handleSearch = (event) => {
    const keyword = event.target.value.toLowerCase();
    setSearchQuery(keyword); // Only set the query
  };

  const handleStatusChange = async (event, row) => {
    const newStatus = event.target.value;
    const kioskId = row.id;
    const clinicName = row.clinicName;
    try {
      setIsLoading(true);
      await apiService.updateShipment({
        kioskId,
        status: newStatus,
        clinicName,
        token: auth,
      });
      Toast.success("Shipment status updated");
      setFilteredDoctors((prevData) =>
        prevData.map((item) =>
          item.id === kioskId ? { ...item, shipStatus: newStatus } : item
        )
      );
    } catch (error) {
      Toast.error("Failed to update Shipment status..!");
    } finally {
      setIsLoading(false);
    }
  };

  const ShipmentStatus = [
    "pending",
    "shipped",
    "in transit",
    "delivered",
    "canceled",
    "returned",
    "delayed",
    "on hold",
  ];

  const columns = [
    {
      field: "clinicName",
      headerName: "Clinic Name",
      align: "center",
    },
    {
      field: "location",
      headerName: "Location",
      align: "center",
    },
    {
      field: "shipStatus",
      headerName: "Ship Status",
      align: "center",
      renderCell: (value, row) => (
        <Select
          value={value}
          onChange={(e) => handleStatusChange(e, row)}
          sx={{ minWidth: 160 }}
        >
          {ShipmentStatus.map((status) => (
            <MenuItem key={status} value={status}>
              {status}
            </MenuItem>
          ))}
        </Select>
      ),
    },
  ];

  return (
    <div>
      <Paper sx={{ padding: 2 }}>
        <Title text="Shipment" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            marginBottom: 2,
          }}
        >
          <TextField
            label="Search"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearch}
            fullWidth
            sx={{ marginBottom: 2, marginTop: 3 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {isMobile ? (
          <CustomCardList
            page={page - 1} // Adjust for zero-based indexing for `CustomTable`
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            fields={[
              { label: "Clinic Name", key: "clinicName" },
              { label: "Location", key: "location" },
            ]}
            data={filteredDoctors}
            DropdownLabel="Shipment Status"
            dropdownField="shipStatus" // Show dropdown for "status"
            dropdownOptions={ShipmentStatus} // Use same options as table
            onDropdownChange={handleStatusChange} // Handle status update
          />
        ) : (
          <CustomTable
            columns={columns}
            data={filteredDoctors}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        )}
      </Paper>
      {isLoading && <PageLoader />}
    </div>
  );
};

export default Shipment;
